<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="modal-title">{{ "i'mselling" | language : "I'm Selling"}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()" class="close-modal-btn">
        {{'cancel' | language : 'cancel'}}
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-segment *ngIf="!isLoading" mode="ios" [(ngModel)]="selectedtab" [value]="selectedtab">
    <ion-segment-button class="ion-text-capitalize" [disabled]="disableProduct" value="product"
      (click)="isSellingService(false)">
      <ion-label>{{'products' | language : 'Products'}}</ion-label>
    </ion-segment-button>
    <ion-segment-button class="ion-text-capitalize" [disabled]="disableService" value="service"
      (click)="isSellingService(true)">
      <ion-label>{{'services' | language : 'Services'}}</ion-label>
    </ion-segment-button>
  </ion-segment>
  <ion-grid *ngIf="!isLoading" class="ion-padding-horizontal ion-padding-bottom">
    <ion-searchbar [debounce]="500" animated color="light" type="text"
      placeholder="{{'Searchbyfruitscategory' | language : 'Search By Product Category'}}" mode="md" id="myInput"
      #search></ion-searchbar>
    <ion-row *ngIf="masterCategoryArray?.length">
      <ng-container *ngFor="let category of getCategoriesData();">
        <ion-col size="6" size-md="3" size-lg="2"
          *ngIf="search.value ? category.name.toLowerCase().includes(search.value.toLowerCase()) : true">
          <div class="ion-text-center card-wrap" (click)="chooseCategory(category)"
            [ngClass]="{'active': category.checked}">
            <ion-icon name="checkmark-circle-sharp" class="checkmark" *ngIf="category.checked"></ion-icon>
            <div
              (click)="categoryPresentinBackend.includes(category.name) ? '' : category.checked = !category.checked; chooseCategory(category)">
              <ion-img [src]="category?.image" alt></ion-img>
              <p class="ion-text-center categoryName">{{category?.id | language
                : category.name}}</p>
            </div>
          </div>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-buttons>
    <ion-button expand="full" (click)="navigate()" class="submit-btn">
      <span class="btn-text">{{'Continue' | language : 'Continue'}}</span>
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-footer>